module.exports = __webpack_public_path__ + "img/05.b1a90699.png";